import { render, staticRenderFns } from "./VideoWall.vue?vue&type=template&id=0acfdfb6&scoped=true"
import script from "./VideoWall.vue?vue&type=script&lang=js"
export * from "./VideoWall.vue?vue&type=script&lang=js"
import style0 from "./VideoWall.vue?vue&type=style&index=0&id=0acfdfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfdfb6",
  null
  
)

export default component.exports